import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CollectionHeaderNav from './CollectionHeaderNav';
import types from '../../common/formElements/CollectionSectionType';
import CustomLoader from '../common/CustomLoader';
import WorkflowBuilder from './collection/workflow/WorkflowBuilder';

export class Workflow extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { projectId, collectionId, version } = this.props.match.params;
    this.props.actions.loadProjectCollectionDetail({ projectId, collectionId, version });
  }

  render() {
    const { collections, match, actions } = this.props;
    const { projectId, collectionId, version } = match.params;
    const {
      loadProjectCollectionDetailPending,
      selectedCollection,
      deleteCollectionWorkflowPending,
    } = collections;

    return (
      <div className="main collections-workflow">
        <div className="section">
          <div className="container">
            <CollectionHeaderNav
              label={types.WORKFLOW}
              projectId={projectId}
              version={version}
              selectedCollection={selectedCollection}
              loadProjectCollectionDetailPending={loadProjectCollectionDetailPending}
            />
            {loadProjectCollectionDetailPending && (
              <div className="text-center">
                <CustomLoader
                  loading={loadProjectCollectionDetailPending}
                  size="20px"
                  color="#303453"
                />
              </div>
            )}
            {selectedCollection && (
              <WorkflowBuilder
                actions={actions}
                version={version}
                projectId={projectId}
                workflows={selectedCollection.workflows}
                collection={selectedCollection}
                collections={collections}
                showWorkflowDeleteLoader={deleteCollectionWorkflowPending}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Workflow);
